module.exports = {
    colorsData: () => {
        return[
            {
                "NUEVO HB20" : {
                    "Colors":[
                        {
                            "Name":"AZUL SAFIRO",
                            "NameAlt":"Azul Safiro",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/KONAPREMIUM/AzulSurfy.webp')
                        },
                        {
                            "Name":"ROJO DRAGON",
                            "NameAlt":"Rojo Dragón",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/HB20ADVANCERIN/RojoDragon.webp')
                        },
                        {
                            "Name":"BLANCO ATLAS",
                            "NameAlt":"Blanco Atlas",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/HB20ADVANCERIN/BlancoAtlas.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/HB20ADVANCERIN/PlataDiamante.webp')
                        },
                        {
                            "Name":"NEGRO SOLIDO",
                            "NameAlt":"Negro Sólido",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/HB20ADVANCERIN/NegroSolido.webp')
                        },
                        {
                            "Name":"GRIS METALIZADO",
                            "NameAlt":"Gris Metalizado",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/HB20ADVANCERIN/GrisMetalizado.webp')
                        },
                    ]
                },

                "NUEVO HB20S" : {
                    "Colors":[
                        {
                            "Name":"AZUL SAFIRO",
                            "NameAlt":"Azul Safiro",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/KONAPREMIUM/AzulSurfy.webp')
                        },
                        {
                            "Name":"ROJO DRAGON",
                            "NameAlt":"Rojo Dragón",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/HB20SADVANCERIN/RojoDragon.webp')
                        },
                        {
                            "Name":"BLANCO ATLAS",
                            "NameAlt":"Blanco Atlas",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/HB20SADVANCERIN/BlancoAtlas.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/HB20SADVANCERIN/PlataDiamante.webp')
                        },
                        {
                            "Name":"NEGRO SOLIDO",
                            "NameAlt":"Negro Sólido",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/HB20SADVANCERIN/NegroSolido.webp')
                        },
                        {
                            "Name":"GRIS METALIZADO",
                            "NameAlt":"Gris Metalizado",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/HB20SADVANCERIN/GrisMetalizado.webp')
                        },
                    ]
                },

                "HB20X ADVANCE" : {
                    "Colors":[
                        {
                            "Name":"ROJO DRAGON",
                            "NameAlt":"Rojo Dragón",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/HB20XADVANCE/RojoDragon.webp')
                        },
                        {
                            "Name":"BLANCO ATLAS",
                            "NameAlt":"Blanco Atlas",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/HB20XADVANCE/BlancoAtlas.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/HB20XADVANCE/PlataDiamante.webp')
                        },
                        {
                            "Name":"GRIS METALIZADO",
                            "NameAlt":"Gris Metalizado",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/HB20XADVANCE/GrisMetalizado.webp')
                        },
                    ]
                },

                "KONA PREMIUM" : {
                    "Colors":[
                        {
                            "Name":"AZUL SURFY",
                            "NameAlt":"Azul Surfy",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/KONAPREMIUM/AzulSurfy.webp')
                        },
                        {
                            "Name":"BLANCO ATLAS",
                            "NameAlt":"Blanco Atlas",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/KONAPREMIUM/BlancoAtlas.webp')
                        },
                        {
                            "Name":"GRIS GALACTICO",
                            "NameAlt":"Gris Galactico",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/KONAPREMIUM/GrisGalactico.webp')
                        },
                        {
                            "Name":"PLATA CIBERNETICO",
                            "NameAlt":"Plata Cibernetico",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/KONAPREMIUM/PlataCibernetico.webp')
                        },
                        {
                            "Name":"ROJO PULSO",
                            "NameAlt":"Rojo Pulso",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/KONAPREMIUM/RojoPulso.webp')
                        },
                    ]
                },

                "KONA LIMITED" : {
                    "Colors":[
                        {
                            "Name":"AZUL SURFY",
                            "NameAlt":"Azul Surfy",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/KONALIMITED/AzulSurfy.webp')
                        },
                        {
                            "Name":"BLANCO ATLAS",
                            "NameAlt":"Blanco Atlas",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/KONALIMITED/BlancoAtlas.webp')
                        },
                        {
                            "Name":"GRIS GALACTICO",
                            "NameAlt":"Gris Galactico",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/KONALIMITED/GrisGalactico.webp')
                        },
                        {
                            "Name":"NEGRO FANTASMA",
                            "NameAlt":"Negro Fantasma",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/KONALIMITED/NegroFantasma.webp')
                        },
                        {
                            "Name":"PLATA CIBERNETICO",
                            "NameAlt":"Plata Cibernetico",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/KONALIMITED/PlataCibernetico.webp')
                        },
                        {
                            "Name":"ROJO PULSO",
                            "NameAlt":"Rojo Pulso",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/KONALIMITED/RojoPulso.webp')
                        },
                    ]
                },

                "TUCSON NX4 PREMIUM" : {
                    "Colors":[
                        {
                            "Name":"BLANCO POLAR",
                            "NameAlt":"Blanco Polar",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/TUCSON/BlancoPolar.webp')
                        },
                        {
                            "Name":"BRONCE SIENA",
                            "NameAlt":"Bronce Siena",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/TUCSON/BronceSiena.webp')
                        },
                        {
                            "Name":"GRIS ASTRAL",
                            "NameAlt":"Gris Astral",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/TUCSON/GrisAstral.webp')
                        },
                        {
                            "Name":"GRIS ORION",
                            "NameAlt":"Gris Órion",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/TUCSON/GrisOrion.webp')
                        },
                        {
                            "Name":"NEGRO FANTASMA",
                            "NameAlt":"Negro Fantasma",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/NegroFantasma.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/PlataDiamante.webp')
                        },
                        {
                            "Name":"ROJO ATARDECER",
                            "NameAlt":"Rojo Atardecer",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/RojoAtardecer.webp')
                        },
                    ]
                },

                "TUCSON NX4 ATTRACTION" : {
                    "Colors":[
                        {
                            "Name":"BLANCO POLAR",
                            "NameAlt":"Blanco Polar",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/TUCSON/BlancoPolar.webp')
                        },
                        {
                            "Name":"BRONCE SIENA",
                            "NameAlt":"Bronce Siena",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/TUCSON/BronceSiena.webp')
                        },
                        {
                            "Name":"GRIS ASTRAL",
                            "NameAlt":"Gris Astral",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/TUCSON/GrisAstral.webp')
                        },
                        {
                            "Name":"GRIS ORION",
                            "NameAlt":"Gris Órion",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/TUCSON/GrisOrion.webp')
                        },
                        {
                            "Name":"NEGRO FANTASMA",
                            "NameAlt":"Negro Fantasma",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/NegroFantasma.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/PlataDiamante.webp')
                        },
                        {
                            "Name":"ROJO ATARDECER",
                            "NameAlt":"Rojo Atardecer",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/RojoAtardecer.webp')
                        },
                    ]
                },

                "TUCSON NX4 LIMITED" : {
                    "Colors":[
                        {
                            "Name":"BLANCO POLAR",
                            "NameAlt":"Blanco Polar",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/TUCSON/BlancoPolar.webp')
                        },
                        {
                            "Name":"BRONCE SIENA",
                            "NameAlt":"Bronce Siena",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/TUCSON/BronceSiena.webp')
                        },
                        {
                            "Name":"GRIS ASTRAL",
                            "NameAlt":"Gris Astral",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/TUCSON/GrisAstral.webp')
                        },
                        {
                            "Name":"GRIS ORION",
                            "NameAlt":"Gris Órion",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/TUCSON/GrisOrion.webp')
                        },
                        {
                            "Name":"NEGRO FANTASMA",
                            "NameAlt":"Negro Fantasma",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/NegroFantasma.webp')
                        },
                        {
                            "Name":"PLATA DIAMANTE",
                            "NameAlt":"Plata Diamante",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/PlataDiamante.webp')
                        },
                        {
                            "Name":"ROJO ATARDECER",
                            "NameAlt":"Rojo Atardecer",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/TUCSON/RojoAtardecer.webp')
                        },
                    ]
                },

                "VENUE PREMIUM MT" : {
                    "Colors":[
                        {
                            "Name":"AZUL INTENSO",
                            "NameAlt":"Azul Intenso",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":require('./../assets/Colores/VENUE/AzulIntensoPerlado.webp')
                        },
                        {
                            "Name":"BLANCO POLAR",
                            "NameAlt":"Blanco Polar",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":require('./../assets/Colores/VENUE/BlancoPolar.webp')
                        },
                        {
                            "Name":"GRIS COSMICO",
                            "NameAlt":"Gris Cósmico",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":require('./../assets/Colores/VENUE/GrisCosmicoPerlado.webp')
                        },
                        {
                            "Name":"NARANJA VOLCAN",
                            "NameAlt":"Naranja Volcán",
                            "Hexa":"#F0F0F0",
                            "HexaAlt":"#DBDBDB",
                            "Image":require('./../assets/Colores/VENUE/NaranjaVolcanPerlado.webp')
                        },
                        {
                            "Name":"PLATA CICLON",
                            "NameAlt":"Plata Ciclón",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/VENUE/PlateadpCiclonMetalizado.webp')
                        },
                        {
                            "Name":"ROJO PASION",
                            "NameAlt":"Rojo Pasión",
                            "Hexa":"#242424",
                            "HexaAlt":"#000000",
                            "Image":require('./../assets/Colores/VENUE/RojoPasionPerlado.webp')
                        },
                    ]
                },

                "STARIA" : {
                    "Colors":[
                    ]
                },

                "STARIA PASAJEROS" : {
                    "Colors":[
                    ]
                },

                "SUPER METRO ACCENT" : {
                    "Colors":[
                    ]
                },

                "GRAND METRO HB" : {
                    "Colors":[
                    ]
                },

                "GRAND METRO SEDAN" : {
                    "Colors":[
                    ]
                },

                "HD78" : {
                    "Colors":[
                        {
                            "Name":"CONGELACION",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":'spins/HD/Carroceria_Congelacion/46.webp'
                        },
                        {
                            "Name":"ESTACAS",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":'spins/HD/Carroceria_Estacas/46.webp'
                        },
                        {
                            "Name":"PLANCHON",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":'spins/HD/Carroceria_Planchon/46.webp'
                        }
                    ]
                },

                "HD65" : {
                    "Colors":[
                        {
                            "Name":"CONGELACION",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":'spins/HD/Carroceria_Congelacion/46.webp'
                        },
                        {
                            "Name":"ESTACAS",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":'spins/HD/Carroceria_Estacas/46.webp'
                        },
                        {
                            "Name":"PLANCHON",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":'spins/HD/Carroceria_Planchon/46.webp'
                        }
                    ]
                },

                "HD55" : {
                    "Colors":[
                        {
                            "Name":"CONGELACION",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":'spins/HD/Carroceria_Congelacion/46.webp'
                        },
                        {
                            "Name":"ESTACAS",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":'spins/HD/Carroceria_Estacas/46.webp'
                        },
                        {
                            "Name":"PLANCHON",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":'spins/HD/Carroceria_Planchon/46.webp'
                        }
                    ]
                },

                "EX8" : {
                    "Colors":[
                        {
                            "Name":"CONGELACION",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":'spins/HD/Carroceria_Congelacion/46.webp'
                        },
                        {
                            "Name":"ESTACAS",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":'spins/HD/Carroceria_Estacas/46.webp'
                        },
                        {
                            "Name":"PLANCHON",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":'spins/HD/Carroceria_Planchon/46.webp'
                        }
                    ]
                },

                "EX10" : {
                    "Colors":[
                        {
                            "Name":"CONGELACION",
                            "Hexa":"#AD0D27",
                            "HexaAlt":"#901025",
                            "Image":'spins/HD/Carroceria_Congelacion/46.webp'
                        },
                        {
                            "Name":"ESTACAS",
                            "Hexa":"#645D5D",
                            "HexaAlt":"#4B4746",
                            "Image":'spins/HD/Carroceria_Estacas/46.webp'
                        },
                        {
                            "Name":"PLANCHON",
                            "Hexa":"#9C9DA1",
                            "HexaAlt":"#828486",
                            "Image":'spins/HD/Carroceria_Planchon/46.webp'
                        }
                    ]
                },

                "GRAND METRO TAXI" : {
                    "Colors":[
                    ]
                },
            }
        ]
    }
}